import {
  type RuntimeState,
  type SignalAdminDraft,
  type SignalDefinition,
} from "./types";

/** Runtime state the draft would produce — mirrors rule_state() in the
 * backend so staged toggles show immediately, before apply. */
export const draftRuntime = (
  definition: SignalDefinition,
  draft: SignalAdminDraft
): RuntimeState => {
  if (definition.implementation_status !== "implemented") return "blocked";
  if (definition.layers.some(layer => draft.layers[layer] === false))
    return "blocked";
  const controls = draft.rules[definition.id];
  if (!controls?.evaluation) return "skipped";
  if (!controls.delivery) return "active_not_delivered";
  return "active";
};
